import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { DataflowService } from '../../../../services/dataflow';

@Component({
  selector: 'app-createdataflowclient',
  templateUrl: './createdataflowclient.component.html',
  styleUrl: './createdataflowclient.component.scss'
})
export class CreatedataflowclientComponent {




  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _dataflow: DataflowService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
        this.initForm();
    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];
        // ✨ املا النموذج من params
// helpers
const toNum = (v: any): number | null =>
  v === null || v === undefined || v === '' || isNaN(+v) ? null : +v;

const toDateYMD = (v: any): string => {
  if (!v) return '';
  // يدعم ISO أو Date أو "YYYY-MM-DD"
  const d = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)
    ? new Date(v)
    : new Date(v);
  if (isNaN(d.getTime())) return '';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
};

// ✨ املا النموذج من params
this.data.patchValue({
  // أساسي
  name: params['name'] ?? '',
  email: params['email'] ?? '',
  password: params['password'] ?? '',    // انت قلت مش مشفّر وعايزه ظاهر
  mobile: params['mobile'] ?? '',
  register_date: toDateYMD(params['register_date']),
  notes: params['notes'] ?? '',

  // التصنيف النهائي
  final_reg_egp: toNum(params['final_reg_egp']),
  final_reg_sar: toNum(params['final_reg_sar']),
  final_reg_pay_method: params['final_reg_pay_method'] ?? '',

  // التسجيل المهني (التصنيف الأول)
  first_class_egp: toNum(params['first_class_egp']),
  first_class_sar: toNum(params['first_class_sar']),
  first_class_pay_method: params['first_class_pay_method'] ?? '',

  // رقم الأحقية
  eligibility_res_egp: toNum(params['eligibility_res_egp']),
  eligibility_res_sar: toNum(params['eligibility_res_sar']),
  eligibility_res_pay_method: params['eligibility_res_pay_method'] ?? '',

  // رسوم الجامعة
  university_fees_egp: toNum(params['university_fees_egp']),
  university_fees_sar: toNum(params['university_fees_sar']),
  university_fees_pay_method: params['university_fees_pay_method'] ?? '',

  // الداتا فلو (جديدة)
  dataflow_egp: toNum(params['dataflow_egp']),
  dataflow_sar: toNum(params['dataflow_sar']),
  dataflow_pay_method: params['dataflow_pay_method'] ?? '',
});


      }
    });


  }

initForm() {
  this.data = this.fb.group({
    // أساسي
    name: ['', Validators.required],
    email: [''],
    password: [''], // هيكون ظاهر مش مشفّر
    mobile: [''],
    register_date: [''],
    notes: [''],

    // التصنيف النهائي
    final_reg_egp: [null],
    final_reg_sar: [null],
    final_reg_pay_method: [''],

    // التسجيل المهني (التصنيف الأول)
    first_class_egp: [null],
    first_class_sar: [null],
    first_class_pay_method: [''],

    // رقم الأحقية
    eligibility_res_egp: [null],
    eligibility_res_sar: [null],
    eligibility_res_pay_method: [''],

    // رسوم الجامعة
    university_fees_egp: [null],
    university_fees_sar: [null],
    university_fees_pay_method: [''],

    // الداتا فلو (جديدة)
    dataflow_egp: [null],
    dataflow_sar: [null],
    dataflow_pay_method: ['']
  });
}


  appendPostDtata() {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      // لو القيمة Boolean، نحولها لقيمة مناسبة
      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0'); // Laravel بيفضل 1 و 0 في boolean
      } else if (value !== null && value !== undefined) {
        this.dataForm.append(key, value.toString());
      }
    });

  }



  onSubmit() {
    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._dataflow.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء العميل" : 'Client created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl ='/dataflow';
       this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل إنشاء العميل" : 'Client not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }

 onEdit() {
   this.contentReady = true;
   this._dataflow.update(this.editId,this.dataForm).subscribe({
     next: (res) => {
       Swal.fire({
         icon: 'success',
         title: this.isAr ? "تم تعديل العميل" : 'Client updated',
         showConfirmButton: false,
         timer: 1500,
       });

       this.contentReady = false;
      const redirectUrl ='/dataflow';
       this.router.navigateByUrl(redirectUrl);
     },
     error: (err) => {
       Swal.fire({
         icon: 'error',
         title: this.isAr ? "فشل تعديل العميل" : 'Client not updated',
         confirmButtonText: this.isAr ? 'تمام' : 'OK',
       });

       this.contentReady = false;
     }
   });
 }





}
